/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Filter_TypeInputs */

const cs_clients_filter_type = /** @type {(inputs: Clients_Filter_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primární typ`)
};

const en_clients_filter_type = /** @type {(inputs: Clients_Filter_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary type`)
};

/**
* | output |
* | --- |
* | "Primary type" |
*
* @param {Clients_Filter_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_filter_type = /** @type {((inputs?: Clients_Filter_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_type(inputs)
	return cs_clients_filter_type(inputs)
});